import React, { useState, useEffect } from 'react'
import { Panel, Message } from 'rsuite'
import scrollToComponent from 'react-scroll-to-component'
import { useForm, Controller } from 'react-hook-form'
import SettingEditFormListWidget from '../dynamicForm/SettingEditFormListWidget'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import { cloneDeep } from 'lodash-es'
import InputForm from '../../../components/forms/input/InputForm'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'
import CKEditorFrom from '../../../components/forms/input/CKEditorFrom'
import ViewButton from '../../../components/buttons/viewButton/ViewButton'
import pathname from '../../../constants/pathname'
import { CANCEL, DEFAULT_ERR_MSG, SAVE, SAVE_SUCCESS_MSG } from '../../../constants/msgText'
import { doneLoading, startLoading } from '../../../utils/loading'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'
import { saveSettingFormProjectObjectiveOutcomeIndicator } from '../../../redux/actions/subProjectFormSetting'
import notification from '../../../utils/notification'
import { createDynamicListReq } from '../../../utils/dynamicListReq'
import EditFormDescriptionWidget from '../dynamicForm/EditFormDescriptionWidget'
import { TEMP_FORM_ID } from '../../../constants/constants'
import { sessionGetItemStr } from '../../../utils/sessionHelpers'

export default function ProjectObjectiveOutcomeIndicatorSettingWidget(props) {
  // const { showCommandButton, isEdit, onChangeIsEdit, isSubProject } = props
  const [section, setSection] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(props.schema)
  const [objectives, setObjectives] = useState([])
  const [newObjectiveIndex, setNewObjectiveIndex] = useState(0)
  const [newOutcomeIndex, setNewOutcomeIndex] = useState(new Map())
  const [notiMsg, setNotiMsg] = useState()
  const [isRefash, setIsRefash] = useState(false)

  const formId = sessionGetItemStr(TEMP_FORM_ID)

  useEffect(() => {
    setObjectives(props.schema?.objectives || [])
  }, [props.schema])

  const handleSave = async (request) => {
    setIsLoading(true)
    startLoading()
    try {
      let response = await saveSettingFormProjectObjectiveOutcomeIndicator(formId, request)
      if (response?.forms?.objectiveOutcomeIndicator) {
        setFormSchema(response.forms.objectiveOutcomeIndicator)
        setObjectives(response.forms.objectiveOutcomeIndicator.objectives || [])
        setNotiMsg({
          type: 'success',
          msg: SAVE_SUCCESS_MSG,
        })
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
          duration: 2500,
        })
        onRefash()
        scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
      } else {
        setNotiMsg({
          type: 'error',
          msg: DEFAULT_ERR_MSG,
        })
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 2500,
        })
      }
    } catch (e) {
      console.log('error', e)
      setNotiMsg({
        type: 'error',
        msg: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
      })
      notification.open('error', {
        title: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
        duration: 2500,
      })
    }
    doneLoading()
    setIsLoading(false)

    setTimeout(() => {
      setNotiMsg('')
    }, 2500)
  }

  const onSubmit = (data) => {
    console.log('data', data)

    let newObjectives = cloneDeep(objectives)

    newObjectives.forEach((item) => {
      //var objectiveValue = data[`${formSchema.inputFrom.objective.name}:${item.id}`]

      item.objective = data[`${formSchema.inputFrom.objective.name}:${item.id}`] || null
      item.note = data[`${formSchema.inputFrom?.objectiveNote?.name}:${item.id}`] || null

      item.newOutcomes?.forEach((outcome) => {
        outcome.outcome = data[`${formSchema.inputFrom.outcome.name}:${outcome.id}`] || null

        let indicaor = createDynamicListReq(
          data[`newObjects:${outcome.id}`],
          data[`newObjectsValuesName:${outcome.id}`]
        )

        outcome.newIndicators = indicaor
      })
      // console.log('objective : ', objective)
    })

    let request = {
      id: formSchema.id,
      values: newObjectives,
      descValues: data.descSettingValues || [],
      descDelIds: data.descDelIds || [],
      detail: data.detail || null,
      note: data.note || null,
    }
    // console.log('request : ', JSON.stringify(request))

    handleSave(request)
  }

  const onRefash = () => {
    setIsRefash(true)
    setTimeout(() => {
      setIsRefash(false)
    }, 50)
  }

  const onAddObjective = () => {
    let newObjectives = cloneDeep(objectives)
    newObjectives.push({
      id: 'NEW_' + (newObjectiveIndex + 1),
      header: 'วัตถุประสงค์',
      objective: '',
      newOutcomes: [],
    })
    setNewObjectiveIndex(newObjectiveIndex + 1)
    setObjectives(newObjectives)
  }

  const onRemoveObjective = (objectiveIndex) => {
    let newObjectives = cloneDeep(objectives)
    newObjectives.splice(objectiveIndex, 1)
    setObjectives(newObjectives)
  }

  const onAddOutcome = (objectiveIndex) => {
    let newObjectives = cloneDeep(objectives)
    let outcomeIndex = cloneDeep(newOutcomeIndex) || new Map()

    let objectiveId = newObjectives[objectiveIndex]?.id
    let idIndex = outcomeIndex.get(objectiveId) || 0

    newObjectives[objectiveIndex].newOutcomes?.push({
      id: 'NEW_:' + objectiveId + ':' + (idIndex + 1),
      header: 'ผลลัพธ์',
      outcome: '',
      newIndicators: [],
    })

    outcomeIndex.set(objectiveId, idIndex + 1)

    setNewOutcomeIndex(outcomeIndex)
    setObjectives(newObjectives)
  }

  const onRemoveOutcome = (objectiveIndex, outcoumIndex) => {
    let newObjectives = cloneDeep(objectives)
    newObjectives[objectiveIndex].newOutcomes.splice(outcoumIndex, 1)
    setObjectives(newObjectives)
  }

  // console.log('formSchema : ', formSchema)

  return (
    <Panel
      shaded
      header={formSchema.header}
      collapsible
      defaultExpanded
      ref={(section) => {
        setSection(section)
      }}
      style={{ marginBottom: 20 }}
    >
      {!isRefash && (
        <>
          {formSchema?.descriptionSetting && (
            <EditFormDescriptionWidget
              schema={formSchema.descriptionSetting}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
            />
          )}

          {formSchema?.inputFrom?.detail && (
            <CKEditorFrom
              schema={formSchema.inputFrom.detail}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
            />
          )}

          {objectives?.map((e, index) => {
            return (
              <Panel
                header={e.header + (objectives?.length > 1 ? ' ที่ ' + (index + 1) : '')}
                collapsible
                defaultExpanded
                bordered
                style={{ marginBottom: 20 }}
              >
                <div style={{ marginTop: -10, marginBottom: 10 }}>
                  <InputForm
                    schema={formSchema.inputFrom.objective}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                    value={e.objective}
                    name={`${formSchema.inputFrom.objective.name}:${e.id}`}
                  />
                </div>

                {e.newOutcomes?.map((se, subIndex) => {
                  return (
                    <Panel
                      header={'ผลลัพธ์ : ' + se.outcome}
                      style={{ marginBottom: 10 }}
                      // collapsible
                      // defaultExpanded
                      bordered
                    >
                      <div style={{ marginTop: -10, marginBottom: 10 }}>
                        {formSchema?.inputFrom?.outcome && (
                          <div style={{ marginBottom: 20 }}>
                            <InputForm
                              schema={formSchema.inputFrom.outcome}
                              register={register}
                              Controller={Controller}
                              control={control}
                              errors={errors}
                              setValue={setValue}
                              clearErrors={clearErrors}
                              value={se.outcome}
                              name={`${formSchema.inputFrom.outcome.name}:${se.id}`}
                            />
                          </div>
                        )}

                        {/* <div style={{ marginBottom: 10 }}>{se.outcome}</div> */}
                        <Panel
                          header={'ตัวชี้วัด'}
                          collapsible
                          defaultExpanded
                          bordered
                          style={{ marginBottom: 20 }}
                        >
                          <div style={{ marginTop: -20, marginBottom: -30 }}>
                            <SettingEditFormListWidget
                              schema={formSchema}
                              register={register}
                              Controller={Controller}
                              control={control}
                              errors={errors}
                              setValue={setValue}
                              clearErrors={clearErrors}
                              setLoading={setIsLoading}
                              inputForm={formSchema.inputFrom}
                              enableAddSub={false}
                              datas={se.newIndicators || []}
                              buttonText={'ตัวชี้วัด'}
                              key={se.id}
                              hideDescriptionSetting={true}
                              newObjectsName={`newObjects:${se.id}`}
                              newObjectsValuesName={`newObjectsValuesName:${se.id}`}
                            />
                          </div>
                        </Panel>
                      </div>
                      <CancelButton
                        icon="trash-o"
                        children={`ลบผลลัพธ์`}
                        onClick={() => {
                          onRemoveOutcome(index, subIndex)
                        }}
                      />
                    </Panel>
                  )
                })}
                <SaveButton
                  icon="plus"
                  children={`เพิ่มผลลัพธ์`}
                  onClick={() => {
                    onAddOutcome(index)
                  }}
                />
                {formSchema?.inputFrom?.objectiveNote && (
                  <div style={{ marginTop: 10, marginBottom: 10 }}>
                    <CKEditorFrom
                      schema={formSchema.inputFrom.objectiveNote}
                      register={register}
                      Controller={Controller}
                      control={control}
                      errors={errors}
                      setValue={setValue}
                      clearErrors={clearErrors}
                      value={e.note}
                      name={`${formSchema.inputFrom.objectiveNote.name}:${e.id}`}
                    />
                  </div>
                )}

                <CancelButton
                  icon="trash-o"
                  children={`ลบวัตถุประสงค์`}
                  onClick={() => {
                    onRemoveObjective(index)
                  }}
                />
              </Panel>
            )
          })}

          <SaveButton
            icon="plus"
            children={`เพิ่มวัตถุประสงค์`}
            onClick={() => {
              onAddObjective()
            }}
          />

          {formSchema?.inputFrom?.note && (
            <CKEditorFrom
              schema={formSchema.inputFrom.note}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
            />
          )}
        </>
      )}

      <hr />
      {notiMsg && (
        <Message
          closable
          showIcon
          type={notiMsg.type}
          description={notiMsg.msg}
          onClose={() => setNotiMsg('')}
          style={{ marginBottom: 10 }}
        />
      )}
      <div className="right">
        <ViewButton
          style={{
            marginRight: 10,
            marginBottom: 10,
          }}
          onClick={() => {
            window.open(
              `${pathname.subProjectNew.proposal.projectObjectiveOutcomeIndicator}?preView`,
              '_blank'
            )
          }}
          children={'แสดงตัวอย่าง'}
        />
        <SaveButton
          children={SAVE + formSchema.buttonText || ''}
          disabled={isLoading}
          onClick={handleSubmit(onSubmit)}
        />
        <CancelButton children={CANCEL} onClick={onRefash} />
      </div>

      {isLoading && <OverlayLoader />}
    </Panel>
  )
}
